// Shared navigation helpers for customer-facing flows.

/**
 * Get the destination for the "Get Free Quotes" CTA.
 * If the customer is already signed in, go straight to the trip form.
 * Otherwise, send them to the login page with a redirect back to the trip form
 * after successful sign-in.
 */
export const getQuotesRoute = () => {
  try {
    const stored = sessionStorage.getItem('customer');
    if (stored) {
      const customer = JSON.parse(stored);
      if (customer && customer.email) {
        return '/trip-form';
      }
    }
  } catch {
    // sessionStorage unavailable or malformed — fall through to login
  }
  return '/customer/login?redirect=/trip-form';
};
